import { render, staticRenderFns } from "./siderWhy.vue?vue&type=template&id=6803b968&"
import script from "./siderWhy.vue?vue&type=script&lang=js&"
export * from "./siderWhy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports